<template>
  <v-card :class="getCardClass()" :style="`width:${width ? width : null}`">
    <v-list-item>
      <v-list-item-avatar
        :style="noGotoProfile ? '' : 'cursor: pointer'"
        @click="noGotoProfile ? null : gotoProfile(userId)"
        :size="avatarSize ? avatarSize : '70'"
      >
        <v-img :src="avatar"></v-img>
      </v-list-item-avatar>

      <v-list-item-content :style="noGotoProfile ? '' : 'cursor: pointer'" @click="noGotoProfile ? null : gotoProfile(userId)">
        <v-list-item-title>
          <span
            style="font-size: 15px"
            class="font-weight-bold defaultColor--text mb-0"
          >
            {{ fullName }}
            ·
            <departmant-icon :departmentName="department" />
          </span>
        </v-list-item-title>

        <v-list-item-subtitle class="mt-1">
          <span style="font-size: 13px" class="defaultColor--text mr-2">{{
            company
          }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action v-if="buttonVisible">
        <v-btn
          color="defaultColor"
          class="white--text text-capitalize mr-2 elevation-0"
          rounded
          small
          :icon="buttonType == 'icon' ? true : false"
          :text="buttonTypeText"
          :disabled="buttonDisabled"
          @click="$emit('sendMessage', item)"
        >

          {{ buttonType == 'icon' ? '' : this.buttonText }}
          <v-icon v-if="buttonType == 'icon'" size="20" >{{this.buttonIconName}}</v-icon>
        </v-btn>
      </v-list-item-action>

      <v-list-item-action v-if="star">
        <v-rating
          v-model="star"
          :length="star"
          readonly
          color="defaultColor"
          small
        ></v-rating>
      </v-list-item-action>
    </v-list-item>

    <v-divider v-if="divider" />
  </v-card>
</template>

<script>
import DepartmantIcon from "../../components/General/DepartmantIcon.vue";

export default {
  data() {
    return {};
  },
  props: {
    item: Object,
    buttonText: String,
    buttonDisabled: Boolean,
    buttonVisible: {
      type: Boolean,
      default: false,
    },
    buttonIconName:{
      type: String,
      default: 'mdi-cloud',
    },
    buttonType: {
      type: String,
      default: 'button',
    },
    userId: {
      type: String,
      default: "",
    },
    noGotoProfile:{
      type: Boolean,
      default: false,
    },
    avatar: String,
    fullName: String,
    department: String,
    company: String,
    noBg: Boolean,
    divider: Boolean,
    star: Number,
    width: String,
    avatarSize: String,
    buttonTypeText: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DepartmantIcon,
  },
  mounted() {},
  methods: {
    getCardClass() {
      if (this.noBg) {
        return "noBgCard";
      } else {
        return "mx-3 defaultCardClass mb-5";
      }
    },
  },
  computed: {},
};
</script>

<style>
.noBgCard {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 0px solid red !important;
  box-shadow: none !important;
}
</style>
